import { ICursorListResponse, XHRInstance } from "@sembark-travel/xhr"

export type TAuthLogUser = {
	id: number
	uid: string
	name: string
}

export type TAuthLog = {
	id: number
	event: string
	method?: string | null
	mfa: boolean
	failure_reason?: string | null
	identifier?: string | null
	ip?: string | null
	country_code?: string | null
	region?: string | null
	city?: string | null
	browser?: string | null
	os?: string | null
	device_type?: string | null
	user_agent?: string | null
	metadata?: Record<string, unknown> | null
	created_at: string
	user?: TAuthLogUser | null
	actor?: TAuthLogUser | null
	tenant?: { id: number; uid: string; name: string } | null
}

export type TAuthLogsRequest = {
	cursor?: string | null
	q?: string
	tenant_uid?: string
	tenants?: Array<number>
	user_id?: number
	events?: Array<string>
	country?: string | null
	exclude_country?: string | null
	created_after?: string | null
	created_before?: string | null
}

export type TAuthLogsSummary = {
	logins: number
	unique_users: number
	failed_logins: number
	locked_out: number
	foreign_logins: number
	unknown_country_logins: number
}

export function authLogsXHR(xhr: XHRInstance) {
	return {
		async get(params: TAuthLogsRequest) {
			return xhr
				.get<ICursorListResponse<TAuthLog>>("/auth-logs", { params })
				.then((resp) => resp.data)
		},
		async getSummary(params: TAuthLogsRequest) {
			return xhr
				.get<{ data: TAuthLogsSummary }>("/auth-logs/summary", { params })
				.then((resp) => resp.data.data)
		},
	}
}
